<app-pageheader Title="Signs">
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="true" ApiUrl="infrastructure/legacysigns/searches"
  [AllowEdit]="true" EditUrl="/parking/guidance/signs/:id/edit" [StructureViewerLayers]="StructureViewerLayers">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>